import axios from 'axios';
import i18next from 'i18next';
import { getTokenData } from 'storage';
import { DEFAULT_LANGUAGE } from 'utils/constants';

export const api = axios.create({
  baseURL: import.meta.env.REACT_APP_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const { forwardAuthorization } = config;
  const token = getTokenData()?.access_token;
  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization =
    forwardAuthorization ?? `Bearer ${token ?? ''}`;

  // eslint-disable-next-line no-param-reassign
  config.headers['Accept-Language'] = i18next.language || DEFAULT_LANGUAGE;

  return config;
});
